/**
 * MediaPackCard - Card do pack de mídias (fechado)
 * Módulo Motorista - Sistema IDOOH
 */

import React from 'react';
import { Package, ChevronRight, DollarSign, Image } from 'lucide-react';
import { MediaPack } from '../types/dashCompanion';

interface MediaPackCardProps {
    pack: MediaPack;
    onOpen: (pack: MediaPack) => void;
}

export function MediaPackCard({ pack, onOpen }: MediaPackCardProps) {
    return (
        <div
            onClick={() => onOpen(pack)}
            className="bg-gradient-to-br from-emerald-600 to-green-700 rounded-2xl p-4 cursor-pointer hover:shadow-xl hover:from-emerald-500 hover:to-green-600 transition-all duration-200 active:scale-[0.98] shadow-lg"
        >
            <div className="flex items-center gap-4">
                {/* Ícone do pack */}
                <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center">
                    <Package className="w-8 h-8 text-white" />
                </div>

                {/* Info */}
                <div className="flex-1">
                    <h3 className="text-lg font-semibold text-white">{pack.name}</h3>
                    <p className="text-sm text-white/70 mt-0.5">{pack.description}</p>

                    <div className="flex items-center gap-4 mt-2">
                        <div className="flex items-center gap-1 text-sm text-white/90">
                            <Image className="w-4 h-4" />
                            <span>{pack.mediaCount} mídias</span>
                        </div>
                        <div className="flex items-center gap-1 text-sm text-yellow-300 font-medium">
                            <DollarSign className="w-4 h-4" />
                            <span>R$ {pack.totalEarnings.toFixed(2)}</span>
                        </div>
                    </div>
                </div>

                {/* Seta */}
                <ChevronRight className="w-6 h-6 text-white/70" />
            </div>

            {/* Preview de thumbnails */}
            <div className="flex gap-2 mt-4 overflow-hidden">
                {pack.medias.slice(0, 4).map((media, index) => (
                    <div
                        key={media.id}
                        className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0 relative border-2 border-white/30"
                        style={{ opacity: 1 - index * 0.1 }}
                    >
                        <img
                            src={media.thumbnailUrl}
                            alt={media.title}
                            className="w-full h-full object-cover"
                        />
                    </div>
                ))}
                {pack.medias.length > 4 && (
                    <div className="w-16 h-16 rounded-lg bg-white/20 flex items-center justify-center flex-shrink-0 border-2 border-white/30">
                        <span className="text-sm font-medium text-white">
                            +{pack.medias.length - 4}
                        </span>
                    </div>
                )}
            </div>

            {/* Botão de ação */}
            <div className="mt-4 pt-3 border-t border-white/20">
                <div className="flex items-center justify-center gap-2 text-white font-medium text-sm">
                    <span>Toque para ver mídias</span>
                    <ChevronRight className="w-4 h-4" />
                </div>
            </div>
        </div>
    );
}

export default MediaPackCard;
